export enum WoundAssessmentStatusEnum {
  NeedsPerformed = 1,
  Performed = 2,
  DidNotPerform = 3
}

export const WoundAssessmentStatusOptions = [
{ id: 1, label: 'Needs Performed' },
{ id: 2, label: 'Performed' },
{ id: 3, label: 'Did Not Perform' }
];
